import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { setAll } from "../../helpers/set-all";

export const loadVideo = createAsyncThunk("video/loadVideo", async () => {
    let headersList = {
        "api-key": process.env.REACT_APP_API_KEY,
    };
    const site = `"CustomerSite":'${process.env.REACT_APP_SITE}'`;
    const data = await axios
        .get(process.env.REACT_APP_API_BASE_URL + "items/Video", {
            headers: headersList,
            params: { populate: "1", filter: `{${site}}` },
        });
    return {
        all: data.data
    }
});

export const loadVideoWithCategory = createAsyncThunk("video/loadVideoWithCategory", async ({ categoryType }) => {
    let headersList = {
        "api-key": process.env.REACT_APP_API_KEY,
    };
    const site = `"CustomerSite":'${process.env.REACT_APP_SITE}'`;
    const filter = { filter: `{"Category":"${categoryType}",${site}}` };

    const data = await axios.get(process.env.REACT_APP_API_BASE_URL + "items/Video", {
        headers: headersList,
        params: filter,
    })

    return {
        category: data.data
    }
});

export const loadVideoWithID = createAsyncThunk("video/loadVideoWithID", async ({ id }) => {
    let headers = {
        "api-key": process.env.REACT_APP_API_KEY,
    };
    const filter = { filter: `{ "_id":'${id}'}` };

    const data = await axios.get(process.env.REACT_APP_API_BASE_URL + "item/Video", {
        headers: headers,
        params: filter,
    });
    return {
        selectedVideo: data.data
    }
});

const videoSlice = createSlice({
    name: "video",
    initialState: {
        loading: true,
        all: [],
        categoryLoading: true,
        category: [],
        selectedVideoLoading: true,
    },
    reducers: {
        fetchVideoSuccess(state, action) {
            setAll(state, action.payload);
        }
    },
    extraReducers: builder => {
        builder
            .addCase(loadVideo.pending, state => {
                state.loading = true;
            })
            .addCase(loadVideo.fulfilled, (state, action) => {
                setAll(state, action.payload);
                state.loading = false;
            })
            .addCase(loadVideo.rejected, (state, { error }) => {
                state.loading = false;
                console.log(error);
            })
            .addCase(loadVideoWithCategory.pending, state => {
                state.categoryLoading = true;
            })
            .addCase(loadVideoWithCategory.fulfilled, (state, action) => {
                setAll(state, action.payload);
                state.categoryLoading = false;
            })
            .addCase(loadVideoWithCategory.rejected, (state, { error }) => {
                state.categoryLoading = false;
                console.log(error);
            })
            .addCase(loadVideoWithID.pending, state => {
                state.selectedVideoLoading = true;
            })
            .addCase(loadVideoWithID.fulfilled, (state, action) => {
                setAll(state, action.payload);
                state.selectedVideoLoading = false;
            })
            .addCase(loadVideoWithID.rejected, (state, { error }) => {
                state.selectedVideoLoading = false;
                console.log(error);
            })
    }

})

export default videoSlice.reducer;

export const { fetchVideoSuccess } = videoSlice.actions;